export interface Empresa {
  id: string;
  nome: string;
  plano: 'start' | 'expert' | 'max_pro';
  produto: string | null;
  feedbacks: number;
  created_at: string;
  voucher_id?: string | null;
  plano_expira_em?: string | null;
  convite_expert_enviado_em?: string | null;
}

export interface Usuario {
  id: string;
  nome: string;
  email: string;
  papel: 'admin' | 'coordenador' | 'vendedor';
  empresa_id: string | null;
  creditos: number;
  created_at: string;
}

export interface ConsumoRow {
  id: string;
  empresa_id: string;
  user_id: string | null;
  persona_id: string | null;
  plano: 'start' | 'expert' | 'max_pro' | null;
  cost_usd: number | null;
  input_tokens: number | null;
  output_tokens: number | null;
  model: string | null;
  created_at: string;
}

export interface LeadCalculadora {
  id: string;
  email: string;
  nome: string | null;
  empresa: string | null;
  vendedores: number | null;
  ticket_medio: number | null;
  vendas_mes: number | null;
  taxa_conversao: number | null;
  roi_calculado: number | null;
  receita_extra_calculada: number | null;
  origem: string | null;
  created_at: string;
}

export interface FeedbackStats {
  mesAtual: number;
  mesAnterior: number;
  total: number;
  custoMesAtual: number;
  custoTotal: number;
}

export const PLANOS = [
  { label: 'Start', value: 'start' },
  { label: 'Expert', value: 'expert' },
  { label: 'Max Pro', value: 'max_pro' },
];

export const PAPEIS = [
  { label: 'Admin', value: 'admin' },
  { label: 'Coordenador', value: 'coordenador' },
  { label: 'Vendedor', value: 'vendedor' },
];

export const PLANO_LABELS: Record<string, string> = {
  start: 'Start',
  expert: 'Expert',
  max_pro: 'Max Pro',
};

export const formatUsd = (value: number) => `$${(value || 0).toFixed(4)}`;

export interface InatividadeRow {
  dias: number;
  nivel: number;
  lembreteEm?: string | null;
}

